const setSearchKeywords = 'SET_SEARCH_KEYWORDS';

const initialState = { keywords: localStorage.getItem('lastItemSearch') };

export const actionCreators = {
    setKeywords: keywords => async (dispatch, getState) => {
        dispatch({ type: setSearchKeywords, keywords });

        localStorage.setItem('lastItemSearch', keywords)
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setSearchKeywords) {
        return {
          ...state,
          keywords: action.keywords
        };
  }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/ProductSearch.js